import React, { useEffect, useState } from 'react';

import { motion } from "framer-motion";

import images from '../libs/images';
import consts from '../libs/consts';

export default function ContainerLoader({
    load,
    full
}) {

    return (
        <motion.div
            className={`container_loader ${full ? 'fixed' : ''}`}
            initial={consts.loaderVariants.closed}
            animate={load ? "open" : "closed"}
            variants={consts.loaderVariants}
        >
            <div className='loading_spin' />
        </motion.div>
    )    
}